const API = process.env.REACT_APP_BACKEND_URL || "";

export async function api(path, options = {}) {
  const res = await fetch(`${API}/api${path}`, {
    ...options,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const detail = data?.detail;
    let msg = "Something went wrong. Please try again.";
    if (typeof detail === "string") msg = detail;
    else if (Array.isArray(detail)) msg = detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(", ");
    else if (typeof detail?.msg === "string") msg = detail.msg;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export function getFragmentToken(key) {
  const hash = window.location.hash.replace(/^#/, "");
  const params = new URLSearchParams(hash);
  const t = params.get("t");
  if (t) sessionStorage.setItem(key, t);
  return t || sessionStorage.getItem(key) || "";
}
